import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { IconArrowRight, IconPersonCircle, IconThreeDotsVertical, IconBoxArrowRight } from './Icons';

const AuthHeader = () => {
  const { user, isAuthenticated, loading, login, logout } = useAuth();
  const [showUserMenu, setShowUserMenu] = useState(false);

  if (loading) {
    return (
      <div className="auth-header">
        <div className="auth-loading">
          <div className="spinner-border spinner-border-sm" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="auth-header">
        <div className="auth-required-card">
          <div className="auth-text-content">
            <div className="auth-message">Authentication Required</div>
            <div className="auth-submessage">Please LOGIN to access Discovery</div>
          </div>
          <button
            type="button"
            className="btn-sign-in"
            onClick={login}
            title="Login with Identity Provider"
          >
            <IconArrowRight aria-hidden />
            <span>LOGIN</span>
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-header">
      <div className="auth-authenticated">
        <div className="user-info-container">
          <div className="user-avatar">
            <IconPersonCircle aria-hidden />
          </div>
          <div className="user-details">
            <div className="user-name">{user.username}</div>
            <div className="user-email">{user.email}</div>
          </div>
          <div className="user-menu">
            <button 
              className="btn-user-menu"
              onClick={() => setShowUserMenu(!showUserMenu)}
              title="User menu"
            >
              <IconThreeDotsVertical aria-hidden />
            </button>
            {showUserMenu && (
              <div className="user-menu-dropdown">
                <button 
                  className="menu-item"
                  onClick={() => {
                    setShowUserMenu(false);
                    logout();
                  }}
                >
                  <IconBoxArrowRight aria-hidden />
                  <span>Sign Out</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthHeader;

